import React, {useEffect, useState} from 'react';
import {getFavoriteCoordinatorList} from '../../api/coordiApi';
import {CoordinatorData} from '../../interface/CoordinatorData';
import {defaultAlert} from '../../utils/alert';
import CoordinatorCard from "../../components/coordinator/CoordinatorCard";
import {EmptyState} from "../../components/common/EmptyStateProps";

const FavoritePage = () => {
    const [coordinators, setCoordinators] = useState<CoordinatorData[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        fetchCoordinators();
    }, []);

    const fetchCoordinators = async () => {
        try {
            setIsLoading(true);
            const res = await getFavoriteCoordinatorList();
            setCoordinators(res.data.data);
        } catch (error) {
            console.error('코디 목록 조회 실패:', error);
            defaultAlert('코디 목록을 불러오는 중 오류가 발생했습니다.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleFavoriteToggle = (coordinatorCode: string) => {
        setCoordinators(prev =>
            prev.filter(coord => coord.coordinatorCode !== coordinatorCode)
        );
    };

    if (isLoading) {
        return <div className="container"><p>로딩 중...</p></div>;
    }

    if (!coordinators || coordinators.length === 0) {
        return (
            <main className="container type_gray">
                <EmptyState message="찜한 코디가 없습니다."/>
            </main>
        );
    }

    return (
        <main className="container type_gray">
            <section>
                <div className="inner-box">
                    {coordinators.map(coordinator => (
                        <CoordinatorCard
                            key={coordinator.coordinatorCode}
                            coordinator={coordinator}
                            onFavoriteToggle={handleFavoriteToggle}
                        />
                    ))}
                </div>
            </section>
        </main>
    );
};

export default FavoritePage;